/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type OrderProductRestaurantQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type OrderProductRestaurantQuery = {
  readonly __typename?: 'Query';
  readonly restaurant: {
    readonly __typename: 'Restaurant';
    readonly id: string;
    readonly name: string;
    readonly latitude: number;
    readonly longitude: number;
    readonly slug: string;
    readonly address: string;
    readonly city: string;
    readonly state: string;
    readonly zipCode: string;
    readonly isOutpost: boolean;
    readonly phone: string;
    readonly flexMessage: string | null;
    readonly isAcceptingOrders: boolean;
    readonly notAcceptingOrdersReason: string;
    readonly hours: { readonly __typename?: 'RestaurantHours'; readonly formatted: string | null };
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
  } | null;
};

export type OrderProductRestaurantDataFragment = {
  readonly __typename: 'Restaurant';
  readonly id: string;
  readonly name: string;
  readonly latitude: number;
  readonly longitude: number;
  readonly slug: string;
  readonly address: string;
  readonly city: string;
  readonly state: string;
  readonly zipCode: string;
  readonly isOutpost: boolean;
  readonly phone: string;
  readonly flexMessage: string | null;
  readonly isAcceptingOrders: boolean;
  readonly notAcceptingOrdersReason: string;
  readonly hours: { readonly __typename?: 'RestaurantHours'; readonly formatted: string | null };
  readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
};

export const OrderProductRestaurantDataFragmentDoc = gql`
  fragment OrderProductRestaurantData on Restaurant {
    id
    __typename
    name
    latitude
    longitude
    slug
    address
    city
    state
    zipCode
    isOutpost
    phone
    hours {
      formatted
    }
    flexMessage
    isAcceptingOrders
    notAcceptingOrdersReason
    asset {
      url
    }
  }
`;
export const OrderProductRestaurantDocument = gql`
  query OrderProductRestaurant($id: ID!) {
    restaurant(id: $id) {
      ...OrderProductRestaurantData
    }
  }
  ${OrderProductRestaurantDataFragmentDoc}
`;

export function useOrderProductRestaurantQuery(
  options: Omit<Urql.UseQueryArgs<OrderProductRestaurantQueryVariables>, 'query'>,
) {
  return Urql.useQuery<OrderProductRestaurantQuery, OrderProductRestaurantQueryVariables>({
    query: OrderProductRestaurantDocument,
    ...options,
  });
}
